var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonRed = function SvgPersonRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18542_22393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18542_22393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62915 9.51758C8.28193 10.1704 9.06665 10.4967 9.98332 10.4967C10.9 10.4967 11.6847 10.1704 12.3375 9.51758C12.9903 8.8648 13.3166 8.08008 13.3166 7.16341C13.3166 6.24674 12.9903 5.46202 12.3375 4.80924C11.6847 4.15647 10.9 3.83008 9.98332 3.83008C9.06665 3.83008 8.28193 4.15647 7.62915 4.80924C6.97637 5.46202 6.64998 6.24674 6.64998 7.16341C6.64998 8.08008 6.97637 8.8648 7.62915 9.51758ZM3.31665 14.8301V17.1634H14.534C14.5051 17.0569 14.4922 16.9494 14.4922 16.8452V15.1099C14.174 15.0398 13.8867 14.8808 13.6473 14.6415C13.3155 14.3097 13.1381 13.8857 13.1381 13.4147V11.7705C12.9897 11.7283 12.8409 11.6891 12.6916 11.653C11.8028 11.4377 10.9 11.3301 9.98332 11.3301C9.06665 11.3301 8.16387 11.4377 7.27498 11.653C6.38609 11.8683 5.51109 12.1912 4.64998 12.6217C4.24721 12.8301 3.92429 13.1322 3.68123 13.528C3.43818 13.9238 3.31665 14.3579 3.31665 14.8301ZM13.9714 12.0408V13.4147C13.9714 13.6629 14.0598 13.8754 14.2366 14.0522C14.4134 14.229 14.6259 14.3174 14.8742 14.3174H15.3256V16.8452C15.3256 16.928 15.3481 16.9976 15.3933 17.054C15.4329 17.1035 15.4812 17.14 15.5382 17.1634H15.7964C15.8565 17.1388 15.9065 17.0967 15.9462 17.037L16.65 16.0196V14.8301C16.65 14.3579 16.5285 13.9238 16.2854 13.528C16.0423 13.1322 15.7194 12.8301 15.3166 12.6217C14.8719 12.3994 14.4235 12.2057 13.9714 12.0408Z",
    fill: "#E53E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5792 17.176C15.5115 17.1534 15.4551 17.1139 15.4099 17.0575C15.3648 17.0011 15.3422 16.9315 15.3422 16.8487V14.321H14.8908C14.6426 14.321 14.43 14.2326 14.2532 14.0558C14.0764 13.879 13.988 13.6665 13.988 13.4182V9.80707C13.988 9.55881 14.0764 9.34628 14.2532 9.16949C14.43 8.99269 14.6426 8.9043 14.8908 8.9043H17.5314C17.7722 8.9043 17.9659 8.99834 18.1126 9.18641C18.2593 9.37449 18.3026 9.58138 18.2424 9.80707L17.5991 12.064H18.107C18.3778 12.064 18.579 12.1844 18.7107 12.4251C18.8423 12.6659 18.8292 12.8991 18.6712 13.1248L15.9629 17.0406C15.9177 17.1083 15.8594 17.1534 15.788 17.176C15.7165 17.1986 15.6469 17.1986 15.5792 17.176Z",
    fill: "#E53E3E"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Person-red.5e2ca8c3.svg";
export { ForwardRef as ReactComponent };